// Demonstration sample deliverables produced from Stag Vault workflows.
// All company names are fictional. No customer data, logos or contact details.
export const SAMPLE_LABEL =
  "Demonstration sample created from a Stag Vault workflow. It is not evidence of customer results.";

// block types: h (heading), p (paragraph), ul (list), table ({head, rows}), kv ([[k, v]])
export const SAMPLE_DELIVERABLES = [
  {
    id: "planned-maintenance-proposal",
    title: "One-Page Service Proposal — Planned Maintenance",
    type: "Service proposal",
    company: "Northwood Joinery (fictional)",
    scenarioId: "jamie-joiner",
    trackSlug: "trades-maintenance-plan-launch",
    trackName: "Trades Planned Maintenance Plan Launch Studio",
    alt: "Sample one-page service proposal for a planned maintenance package from a fictional joinery business, showing three service tiers and next steps",
    summary: "A one-page proposal a trades business could hand to a landlord after a completed job.",
    blocks: [
      { type: "h", text: "Planned Maintenance Partnership — Proposal" },
      { type: "p", text: "Prepared by Northwood Joinery (fictional) for: [Landlord / Property name]. Purpose: keep your properties safe, presentable and let-ready with scheduled visits instead of emergency call-outs." },
      { type: "h", text: "What we check on every visit" },
      { type: "ul", items: ["Doors, locks, hinges and closers", "Windows, seals and trickle vents", "Kitchen units, worktops and fittings", "Skirting, architrave and flooring wear", "Loft hatches, fire doors and intumescent strips", "Written photo report within 48 hours"] },
      { type: "table", head: ["Tier", "Visits / year", "Includes", "Suggested price"], rows: [["Essential", "1", "Annual inspection + report", "£149"], ["Standard", "2", "Two inspections + minor fixes under 30 min", "£299"], ["Complete", "4", "Quarterly inspections + priority call-out + minor fixes", "£499"]] },
      { type: "p", text: "Prices are suggested offer prices for illustration only and should be set against your own costs and local demand." },
      { type: "h", text: "Next step" },
      { type: "p", text: "Reply to this proposal or book a 15-minute walkthrough of one property. No commitment until you have seen the first report." },
    ],
  },
  {
    id: "maintenance-pricing-menu",
    title: "Example Pricing Menu — Maintenance Add-Ons",
    type: "Pricing menu",
    company: "Northwood Joinery (fictional)",
    scenarioId: "jamie-joiner",
    trackSlug: "trades-maintenance-plan-launch",
    trackName: "Trades Planned Maintenance Plan Launch Studio",
    alt: "Sample pricing menu listing optional add-on services with suggested prices for a fictional joinery maintenance plan",
    summary: "An add-on menu that sits alongside the three-tier plan.",
    blocks: [
      { type: "h", text: "Add-on menu (per property)" },
      { type: "table", head: ["Add-on", "What it covers", "Suggested price"], rows: [["Pre-tenancy refresh", "Adjust doors, re-seal windows, touch-up skirting", "£120"], ["Fire-door check", "Gaps, seals, closers, signage — written record", "£45"], ["Handover snag list", "Room-by-room list with photos", "£80"], ["Emergency call-out (plan members)", "Same-week response", "£65 + materials"]] },
      { type: "p", text: "Suggested prices for illustration. Set your own rates from labour cost, travel time and materials." },
    ],
  },
  {
    id: "landlord-planner-page",
    title: "Example Digital Planner Page — Compliance Calendar",
    type: "Digital planner page",
    company: "Harbour Lettings Toolkit (fictional)",
    scenarioId: "priya-lettings",
    trackSlug: "uk-landlord-compliance-planner-kits",
    trackName: "UK Landlord Compliance Planner Kits",
    alt: "Sample digital planner page showing a twelve-month landlord compliance calendar with certificate renewal columns",
    summary: "One page from a printable landlord planner kit — a 12-month certificate and inspection tracker.",
    blocks: [
      { type: "h", text: "12-Month Compliance Calendar — [Property address]" },
      { type: "table", head: ["Item", "Last completed", "Renew by", "Provider", "Done"], rows: [["Gas safety record", "__ / __ / ____", "__ / __ / ____", "", "☐"], ["Electrical (EICR)", "__ / __ / ____", "__ / __ / ____", "", "☐"], ["Smoke & CO alarms tested", "__ / __ / ____", "__ / __ / ____", "", "☐"], ["Energy certificate (EPC)", "__ / __ / ____", "__ / __ / ____", "", "☐"], ["Deposit protection confirmed", "__ / __ / ____", "—", "", "☐"], ["Legionella risk assessment", "__ / __ / ____", "__ / __ / ____", "", "☐"]] },
      { type: "p", text: "Planner pages are organisational tools, not legal advice. Check current requirements for your nation and tenancy type." },
    ],
  },
  {
    id: "planner-pack-launch-plan",
    title: "Example Seven-Day Launch Plan — Planner Pack",
    type: "Launch plan",
    company: "Willow & Vale Planners (fictional)",
    scenarioId: "sam-planner",
    trackSlug: "ai-wedding-planning-planner-packs",
    trackName: "AI Wedding Planning Planner Packs",
    alt: "Sample seven-day launch plan for a digital wedding planner pack, listing one focused task per day",
    summary: "A day-by-day launch week for a first digital product.",
    blocks: [
      { type: "h", text: "Seven-day launch — Budget-Honest Wedding Planner Pack" },
      { type: "table", head: ["Day", "Focus", "Output"], rows: [["1", "Finalise pack", "PDF + editable version exported, file names checked"], ["2", "Listing", "Title, 5 tags, description, 6 preview images"], ["3", "Proof", "Ask two people to buy-test and report confusion"], ["4", "Pins", "10 pins scheduled linking to the listing"], ["5", "Soft launch", "Listing live, first-week discount code"], ["6", "Content", "Three short videos showing pages in use"], ["7", "Review", "Read every message; note the top three questions"]] },
      { type: "p", text: "A plan, not a promise: sales depend on demand, positioning and how well the pack solves a real problem." },
    ],
  },
  {
    id: "creator-content-pack",
    title: "Sample Social-Media Content Pack — Week One",
    type: "Content pack",
    company: "Fictional channel: 'Kitchen Table Finance'",
    scenarioId: "aisha-creator",
    trackSlug: "youtube-automation",
    trackName: "YouTube Automation",
    alt: "Sample content pack for a fictional personal-finance channel showing episode titles, hooks and short-form clip ideas for week one",
    summary: "One week from a 30-day content system: episodes, hooks and clip ideas.",
    blocks: [
      { type: "h", text: "Week 1 — Positioning: 'Money admin for busy households, explained in 8 minutes'" },
      { type: "table", head: ["Episode", "Working title", "Hook (first 5 seconds)", "Clip idea"], rows: [["1", "The 20-minute monthly money reset", "\"You don't need a budget. You need a reset.\"", "The 3-line checklist"], ["2", "Why your subscriptions cost more than you think", "\"I found £41 a month hiding in one app.\"", "Screen-record the audit"], ["3", "The bill negotiation script that actually works", "\"Read this sentence to your provider.\"", "The one-sentence script"]] },
      { type: "ul", items: ["Publishing: Tuesday and Friday, 7pm", "Thumbnail brief: one face, one object, four words max", "Weekly review: retention at 30 seconds, comments answered within 24 hours"] },
    ],
  },
  {
    id: "local-seo-outreach-sequence",
    title: "Sample Outreach Sequence — Local SEO Audit",
    type: "Outreach sequence",
    company: "Brightside Local Marketing (fictional)",
    scenarioId: "marcus-freelance",
    trackSlug: "local-seo-audits",
    trackName: "AI Local SEO Audits",
    alt: "Sample five-touch email outreach sequence from a fictional marketing freelancer offering a local SEO audit",
    summary: "A five-touch email sequence for a fixed-scope audit offer.",
    blocks: [
      { type: "h", text: "Touch 1 — Day 0" },
      { type: "p", text: "Subject: Two things your Google listing is missing. Hi [First name], I checked how [Business] appears when someone nearby searches for [service]. Two quick gaps stood out — I've put them in a two-minute note. Would it help if I sent it over?" },
      { type: "h", text: "Touch 2 — Day 3" },
      { type: "p", text: "Subject: The note I mentioned. Attaching the two gaps plus what a fix looks like. No pitch inside — if it's useful, the full audit covers the other nine checks." },
      { type: "h", text: "Touch 3 — Day 7" },
      { type: "p", text: "Subject: One competitor comparison. Here's how [Competitor] shows up for the same search. The difference is mostly fixable in a fortnight." },
      { type: "h", text: "Touch 4 — Day 12" },
      { type: "p", text: "Subject: Fixed-scope audit — £299. What's included, how long it takes, and what you get back. Optional monthly retainer explained in one paragraph." },
      { type: "h", text: "Touch 5 — Day 18" },
      { type: "p", text: "Subject: Closing the loop. If now isn't right, no problem — I'll leave the two-minute note with you. Reply 'later' and I'll check back next quarter." },
      { type: "p", text: "Suggested prices for illustration only. Placeholder fields in brackets are filled per prospect." },
    ],
  },
  {
    id: "competitor-intelligence-dashboard",
    title: "Sample Competitor-Intelligence Dashboard",
    type: "Dashboard snapshot",
    company: "Brightside Local Marketing (fictional)",
    scenarioId: "marcus-freelance",
    trackSlug: "competitor-intelligence-local-business",
    trackName: "AI-Assisted Competitor Intelligence for Local Businesses",
    alt: "Sample competitor intelligence dashboard table comparing four fictional local businesses across review count, response time, offers and content cadence",
    summary: "A one-screen snapshot delivered with a local audit — fictional businesses throughout.",
    blocks: [
      { type: "h", text: "Local competitor snapshot — [Town], plumbing & heating (fictional data)" },
      { type: "table", head: ["Business (fictional)", "Reviews", "Avg. reply time", "Visible offer", "Posts / month", "Gap to exploit"], rows: [["Ashgrove Heating", "212", "2 days", "Free boiler quote", "4", "Slow replies"], ["Kestrel Plumbing", "58", "Same day", "None", "0", "No offer, no content"], ["Riverline Gas", "140", "1 day", "£20 off service", "2", "Weak photos"], ["Your client", "31", "Same day", "None", "1", "Reviews + offer"]] },
      { type: "ul", items: ["Priority 1: review-request sequence after every job", "Priority 2: a single clear entry offer", "Priority 3: two posts a month with real job photos"] },
    ],
  },
  {
    id: "cafe-onboarding-form",
    title: "Example Client Onboarding Form — Menu Compliance",
    type: "Onboarding form",
    company: "The Copper Kettle Café (fictional)",
    scenarioId: "elena-cafe",
    trackSlug: "cafe-allergen-matrix-menu-compliance-service",
    trackName: "Café Allergen Matrix & Menu-Compliance Service",
    alt: "Sample client onboarding form for a menu compliance service, listing the information a café provides before an allergen matrix is produced",
    summary: "The intake form a café completes before the allergen matrix is produced.",
    blocks: [
      { type: "h", text: "Onboarding — what we need before we start" },
      { type: "kv", items: [["Venue name", "[Venue]"], ["Menu version / date", "[e.g. Autumn menu, v2]"], ["Number of dishes", "[ ]"], ["Supplier spec sheets available?", "Yes / Partly / No"], ["Dishes prepared off-site", "[list]"], ["Shared fryers or prep areas", "Yes / No — describe"], ["Preferred output", "Printed matrix / Laminated card / Digital PDF"], ["Review contact", "[Name, role]"]] },
      { type: "p", text: "The finished matrix summarises information supplied by the venue and its suppliers. The venue remains responsible for accuracy and for meeting its legal obligations." },
    ],
  },
  {
    id: "cafe-delivery-checklist",
    title: "Example Delivery Checklist — Menu Compliance Service",
    type: "Delivery checklist",
    company: "The Copper Kettle Café (fictional)",
    scenarioId: "elena-cafe",
    trackSlug: "cafe-allergen-matrix-menu-compliance-service",
    trackName: "Café Allergen Matrix & Menu-Compliance Service",
    alt: "Sample delivery checklist for a menu compliance service showing steps from intake to handover",
    summary: "The repeatable steps from intake to handover.",
    blocks: [
      { type: "h", text: "Delivery checklist" },
      { type: "ul", items: ["☐ Intake form complete and supplier sheets received", "☐ Every dish mapped to the 14 UK-regulated allergens", "☐ Cross-contact notes added for shared equipment", "☐ Customer-facing menu wording drafted", "☐ Venue review call booked and changes logged", "☐ Final matrix exported in the agreed format", "☐ Seasonal update reminder scheduled", "☐ Invoice sent with next-review date"] },
      { type: "p", text: "A process aid for illustration; adapt it to your own service and local requirements." },
    ],
  },
];

export const getSample = (id) => SAMPLE_DELIVERABLES.find((s) => s.id === id) || null;

export function sampleToText(sample) {
  const lines = [sample.title, sample.company, "", SAMPLE_LABEL, ""];
  for (const b of sample.blocks) {
    if (b.type === "h") lines.push("", `## ${b.text}`);
    if (b.type === "p") lines.push(b.text);
    if (b.type === "ul") lines.push(...b.items.map((i) => `- ${i}`));
    if (b.type === "kv") lines.push(...b.items.map(([k, v]) => `${k}: ${v}`));
    if (b.type === "table") {
      lines.push(`| ${b.head.join(" | ")} |`, `| ${b.head.map(() => "---").join(" | ")} |`);
      lines.push(...b.rows.map((r) => `| ${r.join(" | ")} |`));
    }
  }
  return lines.join("\n");
}
